<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <el-button type="success" @click="getExl" icon="el-icon-download" size="small" plain>导出结果</el-button>

                        <el-input
                            size="small"
                            style="width:220px;margin-left:20px"
                            placeholder="请输入用户 姓名/手机号/QQ"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        
                        <el-date-picker
                        @change="query"
                        :clearable="false"
                        size="small" 
                        style="width:300px;margin-left:20px"
                        v-model="queryModel.createTimes"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>

                        <el-select size="small" style="margin-left:30px;width:100px"   v-model="queryModel.type" clearable placeholder="交易类型">
                            <el-option label="任务佣金" :value="1"> </el-option>
                            <el-option label="推广收入" :value="2"> </el-option>
                            <el-option label="提现" :value="3"> </el-option>
                            <el-option label="任务本金" :value="4"> </el-option>
                            <el-option label="订单撤销" :value="5"> </el-option>
                            <el-option label="好评佣金" :value="6"> </el-option>
                            <el-option label="其它" :value="7"> </el-option>
                            <el-option label="红包收入" :value="8"> </el-option>
                            <el-option label="资损追回" :value="9"> </el-option>
                            <el-option label="财务多转" :value="10"> </el-option>
                            <el-option label="修改垫付补回" :value="11"> </el-option>
                            <el-option label="修改垫付补扣" :value="12"> </el-option>
                            <el-option label="其它佣金" :value="13"> </el-option>
                        </el-select>

                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        
                        <b style="font-size:13px;margin-left:20px">总计：</b>
                        <el-tag class="tag_btn" size="mini"  type="danger" effect="dark">￥{{moneyTotal.toFixed(2)}}</el-tag>

                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :height="bodyHeight-130"
                    :data="tableData"
                    style="width: 100%">
                        <el-table-column
                            prop="Description"
                            label="摘要">
                        </el-table-column>
                        <el-table-column
                            prop="Phone"
                            label="用户手机">
                        </el-table-column>
                        <el-table-column
                            label="金额">
                            <template slot-scope="scope">
                                  <el-link type="primary">￥{{scope.row.Money}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="交易后余额">
                            <template slot-scope="scope">
                                  <el-link type="primary">￥{{scope.row.Balance}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="CreateTime"
                            label="交易时间">
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { swipeBillGetRecord,uri} from '@/request.js'
import { formatDate } from '@/commonUtil.js'

export default {
    components: {
    },
    props:{
      manger:{
        type:Object,
        required: true
      }
    },
    data(){
        return {
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                queryTxt:"",
                type:"",
                createTimes:[],
                pSize:20,
                pIndex:1,
            },
            tableData:[],
            moneyTotal:0,
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        
    },
    mounted(){
        var date=new Date();
        this.queryModel.createTimes.push(new Date(date.getFullYear(),date.getMonth(),date.getDate()));
        this.queryModel.createTimes.push(new Date(date.getFullYear(),date.getMonth(),date.getDate()));
        this.query();
    },
    methods: {
        getExl(){
            let arr=[]
            this.queryModel.createTimes.forEach(x=>{
                console.log(x);
                arr.push(formatDate(new Date(x),"yyyy-MM-dd"))
            });
           window.open(uri+"/SwipeBill/GetRecordExl?queryTxt="+this.queryModel.queryTxt+"&type="+(this.queryModel.type==""?0:parseInt(this.queryModel.type))+"&createTimes="+(this.queryModel.createTimes==null?"[]":JSON.stringify(arr))
           );
       },
        query(){
            this.isLoading=true;
            let arr=[]
            this.queryModel.createTimes.forEach(x=>{
                console.log(x);
                arr.push(formatDate(new Date(x),"yyyy-MM-dd"))
            });
            swipeBillGetRecord({
                pIndex:this.queryModel.pIndex,
                pSize:this.queryModel.pSize,
                queryTxt:this.queryModel.queryTxt,
                type:this.queryModel.type==""?0:parseInt(this.queryModel.type),
                createTimes:this.queryModel.createTimes==null?"[]":JSON.stringify(arr),
            },(res)=>{
                this.tableData=res.Result.List;
                this.moneyTotal=res.Result.Total;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                type:1,
                createTimes:[],
                pSize:20,
                pIndex:1,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>